import React from 'react';

import './AccountMain.css';

import PrivateRoute from 'core/utils/auth/PrivateRoute';
import AccountProfileContainer from '../accountProfile/AccountProfileContainer';
import DeviceChoose from 'features/device/DeviceChoose/DeviceChoose';
import DeviceEditContainer from 'features/device/DeviceEditContainer';
import DeviceListContainer from 'features/device/DeviceListContainer/DeviceListContainer';
import DeviceNewContainer from 'features/device/DeviceNewContainer';
import UserListContainer from 'features/user/UserListContainer/UserListContainer';
import UserNewContainer from 'features/user/UserNewContainer';
import UserEditContainer from 'features/user/UserEditContainer';
import AccountRemindersContainer from '../accountReminders/AccountRemindersContainer';
import ReportSettingsContainer from '../ReportSettingsContainer';

const AccountMain = () => (
  <div className="AccountMain">
    <PrivateRoute exact path="/account" component={AccountProfileContainer} />
    <PrivateRoute exact path="/account/devices" component={DeviceListContainer} />
    <PrivateRoute exact path="/account/devices/choose" component={DeviceChoose} />
    <PrivateRoute exact path="/account/devices/new" component={DeviceNewContainer} />
    <PrivateRoute exact path="/account/devices/:id/edit" component={DeviceEditContainer} />
    <PrivateRoute exact path="/account/reminders" component={AccountRemindersContainer} />
    <PrivateRoute exact path="/account/report-settings" component={ReportSettingsContainer} />
    <PrivateRoute exact path="/account/users" component={UserListContainer} />
    <PrivateRoute exact path="/account/users/:id/edit" component={UserEditContainer} />
    <PrivateRoute exact path="/account/users/new" component={UserNewContainer} />
  </div>
);

export default AccountMain;



// WEBPACK FOOTER //
// ./src/features/Account/AccountMain/AccountMain.jsx